import { render } from "./ModalCardYesNo.vue?vue&type=template&id=c84530a0&scoped=true&ts=true"
import script from "./ModalCardYesNo.vue?vue&type=script&lang=ts"
export * from "./ModalCardYesNo.vue?vue&type=script&lang=ts"

import "./ModalCardYesNo.vue?vue&type=style&index=0&id=c84530a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84530a0"]])

export default __exports__